import {
	isAdvancedHelpCenter,
	isHelpCentersManagement,
} from '@atlassian/help-center-common-util/advanced-help-center';
import { getEnv } from '@atlassian/help-center-common-util/env';
import { isSendRawHelpCenterTypeInAnalyticsEnabled } from '@helpcenter/feature-flags';
import { getHelpCenterAri } from '@helpcenter/meta';
import FeatureGates from '@atlaskit/feature-gate-js-client';

const ADD_EDITION_TO_HELP_CENTER_ANALYTICS = 'help_center_add_edition_to_analytics';
const isAddEditionToHelpCenterAnalyticsEnabled = (): boolean =>
	FeatureGates.checkGate(ADD_EDITION_TO_HELP_CENTER_ANALYTICS);

export const getHelpCenterAnalyticsData = () => {
	if (isHelpCentersManagement()) {
		return undefined;
	}

	const edition = isAddEditionToHelpCenterAnalyticsEnabled() ? getEnv().edition : undefined;

	return {
		helpCenterType: isAdvancedHelpCenter() ? 'custom' : 'default',
		helpCenterAri: getHelpCenterAri(),
		...(edition ? { edition } : {}),
		...(isSendRawHelpCenterTypeInAnalyticsEnabled()
			? { helpCenterCategory: getEnv().helpCenterType }
			: {}),
	};
};
